import Reveal from "@/components/feature/Reveal";
import SectionTitle from "@/components/feature/SectionTitle";
import { reasons } from "@/mocks/reasons";
import MascotAccent from "@/components/feature/MascotAccent";

export default function Reasons() {
  return (
    <section className="relative overflow-hidden bg-background-100 py-16 md:py-24">
      <MascotAccent variant="work" className="right-5 top-8 hidden h-16 w-16 xl:block" />
      <div className="site-container">
        <Reveal>
          <SectionTitle
            upper="REASON"
            under="地域に根ざした建設会社だからこそ、安心してご相談いただける理由があります。"
          >
            小林建設が選ばれる理由
          </SectionTitle>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reasons.map((r, i) => (
            <Reveal key={r.title} delay={i * 60}>
              <div className="grid h-full grid-cols-[auto_1fr] items-start gap-x-4 gap-y-2 rounded-lg border border-background-200 bg-background-50 p-4 md:block md:p-5">
                <span className="col-start-1 row-start-1 flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${r.icon} text-2xl`} />
                </span>
                <h3 className="col-start-2 row-start-1 min-w-0 text-balance font-heading text-lg font-black leading-snug text-foreground-950 md:mt-4">
                  {r.title}
                </h3>
                <p className="col-start-2 row-start-2 min-w-0 text-base leading-relaxed text-foreground-600 md:mt-2">{r.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}